import { Autocomplete, TextField } from '@mui/material';

/**
 * The wireframes' chip input — for long option lists only (states, program years);
 * shorter multi-selects use ChoiceGroup checkboxes instead. Tag styling comes from the
 * theme's MuiAutocomplete override.
 */
export default function ChoiceMultiSelect({ options, value, onChange, placeholder, error = false, disabled = false }) {
  const selected = options.filter((option) => value.includes(option.value));

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      disabled={disabled}
      options={options}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      value={selected}
      onChange={(event, newValue) => onChange(newValue.map((option) => option.value))}
      size="small"
      fullWidth
      renderInput={(params) => (
        <TextField {...params} hiddenLabel placeholder={placeholder} error={error} />
      )}
    />
  );
}
